export const formatNumber = (number, decimals, locale = 'es') => {
    return new Intl.NumberFormat('es').format(parseFloat((number).toFixed(decimals)))
}